var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMovingToGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 8,
  fill: "#FFFBEB"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.6668 9.66667H5.3335M5.3335 9.66667L6.66683 8.33333M5.3335 9.66667L6.66683 11M5.3335 6.33333H10.6668M10.6668 6.33333L9.3335 5M10.6668 6.33333L9.3335 7.66667",
  stroke: "#F59E0B",
  strokeWidth: 0.666667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgMovingToGroup;